import { TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';

export class SolicitudDocumentosExViewModel {
    public Id: number;
    public IdEstadoSolicitudEx = 0;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdTipoSolicitudEx: number;
    public IdTipoSolicitudExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPrevia: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;

    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
    public TDocumentoSolicitudExCollection: TDocumentoSolicitudExViewModel[];
}

export class TDocumentoSolicitudExViewModel {
    public Id: number;
    public IdCopia: number | null = null;
    public IdSolicitudEx: number;
    public IdTipoDocumentacionEx: number;
    public IdTipoDocumentacionExDescripcion: string;
    public Texto = '';
    public Fecha: Date | null = null;
    public IdPais: number | null = null;
    public IdPaisDescripcion: string;
    public CodigoStorage = '';
    public OldCodigoStorageCollection?: string[] = [];
    public NombreArchivo = '';
    public Size: number | null = null;
    public VisibleInspector: boolean | null = false;
    public IdEstadoSolicitudEx = 0;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdTipoSolicitudEx: number;
    public IdTipoSolicitudExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPrevia: boolean;
    public EsCF: boolean;
    public EsEphyto: boolean;
    public FirmadoCF: boolean;
    public EsAlegacion: boolean;
    public Autogenerado: boolean;
    public AttachedEphyto: boolean;
    public Perfil: string;
    public IdUsuario: number;
    public SubidoPorInspector: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;

    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
}
